import { Component, OnInit, Input } from '@angular/core';
import { ItemDetail } from 'src/app/models/item-detail.model';

@Component({
  selector: 'app-call-status',
  templateUrl: './call-status.component.html',
  styleUrls: [
    './call-status.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallStatusComponent implements OnInit {
  @Input() items: ItemDetail[];

  constructor() { }

  ngOnInit(): void {
  }

}
